import { ProductSourcingDetails } from "../models/ProjectManagement/ProjectSourcingDetails";
import { deleteAPI, downloadPDF, getAPI, postAPI } from "./Networking";

export default class ProjectSourcingOpsAPI {
  getSourcingOpsProducts = async (projectId: number) => {
    try {
      const response = await getAPI(`/v5/projects/sourcing/id/${projectId}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  downloadPO = async (id: number) => {
    try {
      const response = await downloadPDF(`/admin/purchaseOrder/download/${id}`);
      return response as Blob;
    } catch (error) {
      throw error;
    }
  };

  getSourcingOpsProductsDetails = async (
    projectId: number,
    productId: number
  ) => {
    try {
      const response = await getAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  saveFilesForPrinting = async (
    projectId: number,
    productId: number,
    imageUrls: string[]
  ) => {
    try {
      const response = await postAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}/files`,
        { image_urls: imageUrls }
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  deleteFilesForPrinting = async (
    projectId: number,
    productId: number,
    id: number
  ) => {
    try {
      const response = await deleteAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}/files/${id}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  saveSourcingOpsBasicDetails = async (
    projectId: number,
    productId: number,
    productDetails: ProductSourcingDetails | null
  ) => {
    try {
      const basicDetailsPayload = {
        id: productDetails?.id ?? null,
        printing_type_id: productDetails?.printing_type_id ?? null,
        printer_id: productDetails?.printer_id ?? null,
        printing_cost: productDetails?.printing_cost ?? null,
      };
      const response = await postAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}/basic-details`,
        basicDetailsPayload
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  saveSourcingOpsOtherDetails = async (
    projectId: number,
    productId: number,
    productDetails: ProductSourcingDetails | null
  ) => {
    try {
      const additionalDetailsPayload = {
        box_sizing: productDetails?.box_sizing ?? null,
        outer_box_sizing: productDetails?.outer_box_sizing ?? null,
        size_mix: productDetails?.size_mix ?? [],
        product_details: productDetails?.product_details ?? null,
      };
      const response = await postAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}/other-details`,
        additionalDetailsPayload
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getTypesOfPrinting = async (productId?: number) => {
    try {
      const response = await getAPI(`/v5/projects/printing_type${productId ? `?product_id=${productId}` : ""}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  deleteVariants = async (projectId: number, productId: number, id: number) => {
    try {
      const response = await deleteAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}/variant/${id}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  updateMockupPriority = async (
    projectId: number,
    productId: number,
    id: number
  ) => {
    try {
      const response = await postAPI(`/v5/mockups/mockup/set-priority`, {
        order_id: projectId,
        product_id: productId,
        mockup_id: id,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  sendMailToClient = async (projectId: number) => {
    try {
      const response = await postAPI(
        `/v5/projects/sourcing/id/${projectId}/email-client`,
        {}
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  sendMailToPrinter = async (projectId: number, productId: number) => {
    try {
      const response = await postAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}/email-printer`,
        {}
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  editCustomization = async (
    projectId: number,
    productId: number,
    customization: boolean
  ) => {
    try {
      const response = await postAPI(
        `/v5/projects/sourcing/id/${projectId}/product_id/${productId}/customization`,
        {
          customization: customization,
        }
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
